import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import ContactSection from "@/components/site/ContactSection";
import StickyBar from "@/components/site/StickyBar";
import Logo from "@/components/site/Logo";
import { BUSINESS } from "@/lib/siteData";

const Footer = () => (
    <footer className="border-t border-amber-500/15 pb-24 md:pb-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
                <Logo size={28} />
                <div className="leading-tight">
                    <p className="font-display font-bold text-slate-100">
                        SHUBHAM <span className="text-amber-400">HOUSING</span>
                    </p>
                    <p className="text-[10px] font-mono2 uppercase tracking-[0.25em] text-amber-400/70">
                        {BUSINESS.tagline}
                    </p>
                </div>
            </div>
            <p className="text-xs text-slate-500 text-center sm:text-right">
                {BUSINESS.director}, {BUSINESS.role} • {BUSINESS.phone1Display} /{" "}
                {BUSINESS.phone2Display}
                <br />© {new Date().getFullYear()} Shubham Housing, Gurugram. All rights reserved.
            </p>
        </div>
    </footer>
);

function App() {
    return (
        <div className="min-h-screen bg-[#0B132B] text-slate-50">
            <Header />
            <main>
                <Hero />
                <div className="gold-divider h-px max-w-5xl mx-auto" aria-hidden="true" />
                <Services />
                <ContactSection />
            </main>
            <Footer />
            <StickyBar />
        </div>
    );
}

export default App;
